import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import { NotificationBox, Alert, Topbar } from '../_webview';
import { NotificationBoxPreview, AlertPreview, TopbarPreview } from './WebviewPreview';

const selectValues = [
  { label: <div><i className="linearicons-alarm-ringing" style={{marginRight: "15px"}}></i> Notificação padrão</div>, value: "notification_box" },
  { label: <div><i className="linearicons-window" style={{marginRight: "15px"}}></i> Barra de topo</div>, value: "topbar" },
  { label: <div><i className="linearicons-siren" style={{marginRight: "15px"}}></i> Alerta</div>, value: "alert_box" }
]

const selectDevicesValues = [
  { label: <div><i className="linearicons-laptop-phone" style={{marginRight: "15px"}}></i> Todos os dispositivos</div>, value: "devices_all" },
  { label: <div><i className="linearicons-smartphone"></i><i className="linearicons-tablet" style={{marginRight: "15px"}}></i> Somente dispositivos móveis</div>, value: "devices_mobile" },
  { label: <div><i className="linearicons-smartphone" style={{marginRight: "15px"}}></i> Somente smartphones</div>, value: "devices_smartphone" },
  { label: <div><i className="linearicons-tablet" style={{marginRight: "15px"}}></i> Somente tablets</div>, value: "devices_tablets" },
  { label: <div><i className="linearicons-desktop" style={{marginRight: "15px"}}></i> Somente desktops/laptops</div>, value: "devices_desktops" }
]

class WebviewCustomization extends Component {
  constructor(props) {
    super(props);

    this.state = {
      webview_type: '',
      webview_mode: 'devices_all',
      webview_props: {},

      modalIsOpen: false
    }
    
    this.handleWebviewTypeChange = this.handleWebviewTypeChange.bind(this);
    this.handleModeTypeChange = this.handleModeTypeChange.bind(this);
    this.handleWebviewProps = this.handleWebviewProps.bind(this);
    this.handleModal = this.handleModal.bind(this);
  }

  handleWebviewTypeChange(e) {
    this.setState({webview_type: e.value});
  }

  handleWebviewProps(obj, shouldFinish) {
    this.setState({webview_props: obj, modalIsOpen: shouldFinish});
  }

  handleModeTypeChange(e) {
    this.setState({webview_mode: e.value});
  }

  handleModal(e) {
    let { modalIsOpen } = this.state;
    this.setState({modalIsOpen: !modalIsOpen});
  }

  render() {
    let { webview_type } = this.state;

    const defineWebviewComponent = () => {
      switch(webview_type) {
        case "notification_box": return <NotificationBox key="notificationProps" handleWebviewProps={this.handleWebviewProps} />;
        case "alert_box": return <Alert key="alertProps" handleWebviewProps={this.handleWebviewProps}/>;
        case "topbar": return <Topbar key="topbarProps" handleWebviewProps={this.handleWebviewProps}/>;
        default: break;
      }
    }

    const defineWebviewComponentPreview = () => {
      switch(webview_type) {
        case "notification_box": return <NotificationBoxPreview {...this.state.webview_props} />;
        case "alert_box": return <AlertPreview {...this.state.webview_props} />;
        case "topbar": return <TopbarPreview {...this.state.webview_props} />;
        default: break;
      }
    }

    return (
      <>
        <button type="button" className="btn btn-white customize-message" onClick={this.handleModal} data-modal-show="true">{this.props.data.viewMode ? `Visualizar mensagem` : `Customizar mensagem`}</button>
        <input type="hidden" name="channel-values" id="channel-values" value={JSON.stringify({webview_type: this.state.webview_type, webview_mode: this.state.webview_mode, webview_props: this.state.webview_props})}/>

        <Modal
          className="custom-card-modal customize-message"
          size="lg-fluid"
          show={this.state.modalIsOpen}
          onHide={this.handleModal}
          centered
        >
          <Modal.Body>
            <p className="custom-modal-title">Construa sua própria notificação <i>on-site</i> customizada.</p>
            
            <div className="form">
              <div className="row">
                <div className="col-6">
                  <div className="content-group no-shadow" style={{marginBottom: 0}}>
                    <p className="group-title">Selecione o tipo da sua notificação:</p>

                    <div className="row">
                      <div className="col-6">
                        <Select
                          options={selectValues}
                          className="basic-select"
                          classNamePrefix="select"
                          placeholder="Tipos de notificações"
                          onChange={this.handleWebviewTypeChange}
                          isDisabled={this.props.data.viewMode}
                        />
                      </div>
                      <div className="col-6">
                        <Select
                          options={selectDevicesValues}
                          className="basic-select"
                          classNamePrefix="select"
                          placeholder="Dispositivos (Padrão: Todos)"
                          onChange={this.handleModeTypeChange}
                          isDisabled={this.props.data.viewMode}
                        />
                      </div>
                    </div>

                    { webview_type ? defineWebviewComponent() : null }
                  </div>
                </div>
                  <div className="col-6">
                    <p className="group-title">Visualização:</p>
                    <div className="editor-group">
                      <div className="pagelayout">
                        <div className="pagelayout-header">
                          <span className="address"></span>
                          <span className="minimize"></span>
                          <span className="expand"></span>
                          <span className="close"></span>
                        </div>
                        <div className="pagelayout-body">
                          { webview_type ? defineWebviewComponentPreview() : null }
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    )
  }
}

export default WebviewCustomization;